<template lang='pug'>
footer(:class="{'show-funneled': $route.meta.showSocialFooter}")
  .footer-contents.main-container(data-track="footer" @click="footerActions($event)")
    debug-modal(v-if="showDebug" @close="showDebug = false")
    footer-static
    mobile-actions(:class="{'show-funneled': $route.meta.showSocialFooter}")
    desktop-actions(:class="{'show-funneled': $route.meta.showSocialFooter}")
    .mark
      StaticImage.logo( src="/UI/logos/rogue-logo-classic_ifo2pb.svg" alt="Rogue Fitness" :width="148" :height="36" lazy ssr contain)
      .copyright {{ __(copyright) }}
      .link.debug.copyright(v-if="canDebug" @click="showDebug = true") Debug
</template>

<script setup lang="ts">
import { defineAsyncComponent, onMounted, ref } from 'vue'
import DesktopActions from './desktop-actions.vue'
import FooterStatic from './static.vue'
import MobileActions from './mobile-actions.vue'
import { useUIStore } from '@/js/stores/uiStore'
import { useRogue } from '@/js/services/Rogue'

const DebugModal = defineAsyncComponent(() => import(/* webpackChunkName: "debug" */'@/js/pages/checkout/components/debug-modal.vue'))

const copyright = `© 2010-${new Date().getFullYear()} Rogue Fitness. All Rights Reserved.`
const showDebug = ref(false)
const canDebug = ref(false)

const uiStore = useUIStore()
const rogue = useRogue()

onMounted(() => {
  canDebug.value = !!rogue.debug
})

function footerActions(e: Event) {
  const tgt = e.target as HTMLElement

  if (tgt?.getAttribute('action') === 'showOverlay') {
    uiStore.showOverlay(tgt.getAttribute('name') || '', rogue)
  }
}

</script>

<style lang='scss' scoped>

footer {
  background: $color-black;
  overflow: hidden;
  color: $color-white;

  #app.funneled & {
    &:not(.show-funneled) {
      padding-bottom: 104px;
    }

    .mobile-actions:not(.show-funneled), .desktop-actions {
      display: none;
    }

    @include all-desktop() {
      padding-bottom: $space-l;

      .footer-contents {
        justify-content: space-between;
        align-items: center;
      }

      .mark {
        margin: 0;
        width: auto;
        text-align: right;
      }

      .static {
        flex-grow: 0;
      }

      .funneled {
        margin-bottom: 0;
      }
    }
  }
}

.debug {
  font-size: 10px;
  margin-top: $space-s;
}

.static {
  flex-grow: 1;
}

.footer-contents {
  padding: $space-l 0;
}

@include not-mobile() {
  .footer-contents {
    padding: $space-l;
  }
}

.desktop-actions {
  display: none;
}

@include all-desktop() {
  .footer-contents {
    flex-wrap: wrap;
    display: flex;
  }

  .desktop-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    flex-shrink: 0;
  }

  .mobile-actions {
    display: none;
  }
}

.mark {
  width: 100%;
  margin: $space-m 0;
  text-align: center;
}

.logo {
  display: inline-block;
  margin-bottom: $space-xs;
  width: 148px
}

.copyright {
  color: $color-gray-dark;
  font-size: $size-xs;
}

</style>
